import React, { Fragment } from 'react'

import PropTypes from 'prop-types'

import './steps2.css'

const Steps2 = (props) => {
  return (
    <div className="steps2-container1 thq-section-padding">
      <div className="steps2-max-width thq-section-max-width">
        <div className="steps2-container2 thq-grid-2">
          <div className="steps2-section-header">
            <h2 className="thq-heading-2">
              Discover the Power of Our Products
            </h2>
            <div className="steps2-actions"></div>
          </div>
          <div className="steps2-container3">
            <div className="steps2-container4 thq-card">
              <h2 className="thq-heading-2">
                {props.step1Title ?? (
                  <Fragment>
                    <span className="steps2-text28">Initial Consultation</span>
                  </Fragment>
                )}
              </h2>
              <span className="steps2-text12 thq-body-small">
                {props.step1Description ?? (
                  <Fragment>
                    <span className="steps2-text32">
                      Schedule a consultation with our team to discuss your
                      business goals and requirements.
                    </span>
                  </Fragment>
                )}
              </span>
              <label className="steps2-text13 thq-heading-3">01</label>
            </div>
            <div className="steps2-container5 thq-card">
              <h2 className="thq-heading-2">
                {props.step2Title ?? (
                  <Fragment>
                    <span className="steps2-text26">Trade License Setup</span>
                  </Fragment>
                )}
              </h2>
              <span className="steps2-text15 thq-body-small">
                {props.step2Description ?? (
                  <Fragment>
                    <span className="steps2-text34">
                      We will assist you in obtaining the necessary trade
                      license for your startup in Abu Dhabi.
                    </span>
                  </Fragment>
                )}
              </span>
              <label className="steps2-text16 thq-heading-3">02</label>
            </div>
            <div className="steps2-container6 thq-card">
              <h2 className="thq-heading-2">
                {props.step3Title ?? (
                  <Fragment>
                    <span className="steps2-text31">
                      Office Space Solutions
                    </span>
                  </Fragment>
                )}
              </h2>
              <span className="steps2-text18 thq-body-small">
                {props.step3Description ?? (
                  <Fragment>
                    <span className="steps2-text27">
                      Explore our office space options tailored to meet the
                      needs of your growing business.
                    </span>
                  </Fragment>
                )}
              </span>
              <label className="steps2-text19 thq-heading-3">03</label>
            </div>
            <div className="steps2-container7 thq-card">
              <h2 className="thq-heading-2">
                {props.step4Title ?? (
                  <Fragment>
                    <span className="steps2-text30">Select Services</span>
                  </Fragment>
                )}
              </h2>
              <span className="steps2-text21 thq-body-small">
                {props.step4Description ?? (
                  <Fragment>
                    <span className="steps2-text33">
                      Choose the services you need assistance with, such as PRO,
                      HR, Accounts, IT, and website creation.
                    </span>
                  </Fragment>
                )}
              </span>
              <label className="steps2-text22 thq-heading-3">04</label>
            </div>
            <div className="steps2-container8 thq-card">
              <h2 className="thq-heading-2">
                {props.step3Title1 ?? (
                  <Fragment>
                    <span className="steps2-text35">Get Started</span>
                  </Fragment>
                )}
              </h2>
              <span className="steps2-text24 thq-body-small">
                {props.step3Description1 ?? (
                  <Fragment>
                    <span className="steps2-text29">
                      Let us handle the setup process and support services while
                      you focus on launching and growing your business.
                    </span>
                  </Fragment>
                )}
              </span>
              <label className="steps2-text25 thq-heading-3">03</label>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

Steps2.defaultProps = {
  step2Title: undefined,
  step3Description: undefined,
  step1Title: undefined,
  step3Description1: undefined,
  step4Title: undefined,
  step3Title: undefined,
  step1Description: undefined,
  step4Description: undefined,
  step2Description: undefined,
  step3Title1: undefined,
}

Steps2.propTypes = {
  step2Title: PropTypes.element,
  step3Description: PropTypes.element,
  step1Title: PropTypes.element,
  step3Description1: PropTypes.element,
  step4Title: PropTypes.element,
  step3Title: PropTypes.element,
  step1Description: PropTypes.element,
  step4Description: PropTypes.element,
  step2Description: PropTypes.element,
  step3Title1: PropTypes.element,
}

export default Steps2
